(function() {
    angular
        .module('emarket.main.post')
        .controller('AskAuthenticationController', ['$mdDialog', '$rootScope', function($mdDialog, $rootScope) {
            var vm = this;
            vm.close = function() {
                $mdDialog.hide();
            };
            $rootScope.$on('$stateChangeSuccess', function() {
                vm.close();
            });
        }]);
}());
